import React, { useState } from "react";

export const CertificationCallContext = React.createContext({});

export function CertificationCallProvider({ children }: { children: React.ReactNode }) {
  const [callStatus, setCallStatus] = useState<"idle" | "loading" | "calling" | "connected" | "ended">("idle");
  const [assignment, setAssignment] = useState<any>(null);

  const values = {
    callStatus,
    setCallStatus,
    assignment,
    setAssignment,
  };

  return (
    <CertificationCallContext.Provider value={values}>
      {children}
    </CertificationCallContext.Provider>
  );
}

export function useCertificationCall(): {
  callStatus: "idle" | "loading" | "calling" | "connected" | "ended";
  setCallStatus: React.Dispatch<React.SetStateAction<"idle" | "loading" | "calling" | "connected" | "ended">>;
  assignment: any;
  setAssignment: React.Dispatch<React.SetStateAction<any>>;
} {
  const context = React.useContext(CertificationCallContext);
  if (!context) {
    throw new Error("useCertificationCall must be used within CertificationCallProvider");
  }
  return context as any;
}

